import React from 'react';
import _ from 'lodash';

import { useStoreSettingsActivity_UsersTabQuery } from 'generated/graphql';
import { DateTime } from 'luxon';



export interface IInvite {
  id: string;
  sentAt: DateTime | null;
  recipientEmail: string;
}

export interface IUser {
  id: string;
  email: string;
  fullName: string;
}

export interface IData {
  invites: IInvite[];
  users: IUser[];
}

export function useQuery(storeId: string) {
  const tuple = useStoreSettingsActivity_UsersTabQuery({
    variables: {
      storeId
    }
  });



  return React.useMemo(
    () => {
      const users = _.map(tuple.data?.store?.users.nodes ?? [], (node): IUser => ({
        id: node.id,
        fullName: node.fullName,
        email: node.email
      }));

      const unclaimedInvites = _.filter(tuple.data?.store?.invites.nodes ?? [], node => !node.isClaimed);
      const invites = _.map(unclaimedInvites, (invite): IInvite => ({
        id: invite.id,
        sentAt: invite.sentTimestamp ? DateTime.fromISO(invite.sentTimestamp) : null,
        recipientEmail: invite.recipientEmail
      }));
      const data: IData = {
        users,
        invites
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
